import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './gReCaptcha.html?raw';
import docu from './gReCaptchaDocumentation.html?raw';
//import DataItems = require("DataItems");


class gReCaptcha extends compose(_LabelInputBase) {
    templateString: any = template;

    recaptcha_container: HTMLElement;
    button: HTMLButtonElement;
    recaptcha_id: string;

    invisible: boolean = false;

    sitekey: string = "6Lc_QdEZAAAAAPZ31r_sLQ-IBMfFxhwz6DNQD0nm"; // HTML tag attribut: "data-sitekey"  - your sitekey.
    theme: string; // data-theme - Optional. The color theme of the widget. dark || light. Default value == light
    size: string = "normal"; // data-size - Optional. The size of the widget. normal || compact || invisible(for V2-invisible - SCHLÜSSEL AKTIVIEREN!!!).  Default value == compact.
    tabindex: number = 0; // data-tabindex - Optional. The tabindex of the widget and challenge. If other elements in your page use tabindex, it should be set to make user navigation easier. Def.value == 0.
    callback: string = "reCaptcha_dataCallback"; // data-callback - Optional. The name of your callback function, executed when the user submits a successful response. The g-recaptcha-response token is passed to your callback.
    expired_callback: string; // data-expired-callback. in settings-object: 'expired-callback'. Optional. The name of your callback function, executed when the reCAPTCHA response expires and the user needs to re-verify.
    error_callback: string; // data-error-callback. in settings-object: "error-callback". Optional. The name of your callback function, executed when reCAPTCHA encounters an error (usually network connectivity) and cannot continue until connectivity is restored. If you specify a function here, you are responsible for informing the user that they should retry.

    // for invisible: this.size == invisible - the key registration must correspond.
    badge: string; // data-badge - Optional. Reposition the reCAPTCHA badge. 'inline' lets you position it with CSS. Possible Values: bottomright || bottomleft || inline. Def Value == bottomright.     

    renderSettings: object = {};

    renderCaptcha():void {

        this.recaptcha_id = window.grecaptcha.render(this.recaptcha_container,
            //{
            //    'sitekey': '6Lc_QdEZAAAAAPZ31r_sLQ-IBMfFxhwz6DNQD0nm',
            //    'theme': 'light',
            //    'size': 'normal',
            //    'callback': 'reCaptcha_dataCallback'
            //}
            this.renderSettings
        );
    };

    populateRenderSettings(): void {
        this.renderSettings["sitekey"] = this.sitekey;
        this.renderSettings["theme"] = this.theme;
        this.renderSettings["size"] = this.size;
        this.renderSettings["tabindex"] = this.tabindex;
        this.renderSettings["callback"] = this.callback;
        this.renderSettings["expired_callback"] = this.expired_callback;
        this.renderSettings["sitekey"] = this.sitekey;
        this.renderSettings["error_callback"] = this.error_callback;
        if (this.badge) {
            this.renderSettings["badge"] = this.badge;
        }
        
    }


    _registerGlobalCallbacks(): void { 
        window["reCaptcha_dataCallback"] = function (respToken: string): void {
            window.dojo.publish("/grecaptcha/callback", [respToken]);
        }
    }

    verifyCaptchaToken(respToken?: string): void {

        let requestUrl = window.appRoot + "demodata/ValidateCapture"
        let requestParams = { "jsonData": JSON.stringify({ recapture_response: respToken }) };
        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "verifyCaptchaToken_completeHandler"),
            lang.hitch(this, "verifyCaptchaToken_errorHandler")
        );

    }

    verifyCaptchaToken_completeHandler(response: any): void {
        console.log("verifyCaptchaToken_completeHandler:: ", response);
        if (response["message"] == "success") {
            // do something if success
            this.emit("reCaptcha_validationSuccess");
            window.grecaptcha.reset();
        }
    }

    verifyCaptchaToken_errorHandler(err: any): void {
        console.log("verifyCaptchaToken_errorHandler:: ", err);
    }

    checkReCaptcha(): void {
        window.grecaptcha.execute();
    }



    _onclick_Check_check(): void {
        this.checkReCaptcha();
    }

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // Getters & setters ---------------------------------START
    setSiteKey(sitekey: string): void {
        this.sitekey = sitekey;
    }
    setTheme(theme: string): void {
        this.theme = theme;
    }
    setSize(size: string): void {
        this.size = size;
    }
    setTabIndex(tabindex: number): void {
        this.tabindex = tabindex;
    }
    setCallback(callback: string): void {
        this.callback = callback;
    }
    seBadge(badge: string): void {
        this.badge = badge;
    }
    _setSitekeyAttr(sitekey: string): void {
        this.setSiteKey(sitekey);
    }
    setExpiredCallback(expired_callback: string): void {
        this.expired_callback = expired_callback;
    }
    setErrorCallback(error_callback: string): void {
        this.error_callback = error_callback;
    }
    setInvisible(bool: boolean): void {
        this.invisible = bool;
        this.size = "invisible"
    }
    _setThemeAttr(theme: string): void {
        this.setTheme(theme);
    }
    _setSizeAttr(size: string): void {
        this.setSize(size);
    }
    _setTabindexAttr(tabindex: number): void {
        this.setTabIndex(tabindex);
    }
    _setCallbackAttr(callback: string): void {
        this.setCallback(callback);
    }
    _setExpired_callbackAttr(expired_callback: string): void {
        this.setExpiredCallback(expired_callback);
    }
    _setError_callback(error_callback: string): void {
        this.setErrorCallback(error_callback);
    }
    _setBAdgeAttr(badge: string): void {
        this.seBadge(badge);
    }
    _setInvisibleAttr(bool: boolean): void {
        this.setInvisible(bool);
    }

    // Getters & setters ---------------------------------END

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.button, "button");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.populateRenderSettings()
        this._registerGlobalCallbacks();
        this.addSubscription("/grecaptcha/callback", lang.hitch(this, "verifyCaptchaToken"));
        this.renderCaptcha();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(gReCaptcha);